module.exports = "/_next/static/images/e353ef7ce3dfcdc2cc5135ef659bda7b-website-thumb.jpg.webp";